<modal [name]="localStorageKeys.ti_modal_iframe_content" [minWidth]="350" [style.height]="height || '100%'" [style.width]="width || '100%'" (closeOut)="close.emit(false);" class="iframe-dialog">
  <modal-header>
    <span class="title">{{title}}</span>
  </modal-header>
  <modal-body>
    <ti-content class="main" #content [url]="url"></ti-content>
  </modal-body>
</modal>
